import React from 'react'
import { Route } from 'lucide-react'
import { Tooltip } from 'antd'
import dayjs from 'dayjs'
import { useSelector, useDispatch } from 'react-redux'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { updateContextFilterAction, setPeriodGroupFilter } from '../../../redux/context/filters/actions'
import { AppDispatch } from '../../../redux/store'
import { useCtxScenarios } from '../../scenario/queries/useCtxScenarios'
import CtxScenarioIconSelect from '../../scenario/components/select/CtxScenarioIconSelect'
import LucideIcon from '../../../shared/components/LucideIcon'

const ContextScenarioSelect: React.FC = () => {
  const dispatch: AppDispatch = useDispatch()
  const filters = useSelector(filtersSelector)
  const { data: scenarios } = useCtxScenarios()

  const hasScenario = !!filters?.budgetingScenario?.id
  const forecastCursor = filters?.budgetingScenario?.forecastCursor

  const handleScenarioChange = (scenarioId: number) => {
    if (scenarioId !== filters.budgetingScenario?.id) {
      const budgetingScenario = scenarios?.find(scenario => scenario.id === scenarioId)
      if (!budgetingScenario) return
      dispatch(setPeriodGroupFilter(undefined))
      dispatch(updateContextFilterAction({ budgetingScenario }))
    }
  }

  return (
    <Tooltip title={forecastCursor ? dayjs(forecastCursor).format('MM/YYYY') : undefined}>
      <CtxScenarioIconSelect
        data-cy="context-scenario-select"
        className={hasScenario ? 'active' : undefined}
        prefix={<LucideIcon icon={Route} />}
        style={{ width: 200 }}
        styles={{ popup: { root: { minWidth: 400 } } }}
        value={filters?.budgetingScenario?.id}
        onChange={handleScenarioChange}
      />
    </Tooltip>
  )
}

export default ContextScenarioSelect
